const isNan = (n: any) => typeof n === 'number' && isNaN(n);
export default isNan;
